module.exports = __webpack_public_path__ + "img/icon_service_06.e906e0b5.png";